export default __webpack_public_path__ + "static/media/unionpay.fd954208.png";